import * as Types from '../../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserInfoFragmentDoc } from '../../../view/components/__generated__/organisation.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetInvitationsFromFamilyCaregiversQueryVariables = Types.Exact<{
  organisationUuid: Types.Scalars['String']['input'];
}>;


export type GetInvitationsFromFamilyCaregiversQuery = { __typename?: 'Query', invitationsFromFamilyCaregivers: Array<{ __typename?: 'Invite', id: string, status: Types.FriendshipRequestStatus, fromUser: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null, role: string }, toUser: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null, role: string } }> };


export const GetInvitationsFromFamilyCaregiversDocument = gql`
    query GetInvitationsFromFamilyCaregivers($organisationUuid: String!) {
  invitationsFromFamilyCaregivers(organisationUuid: $organisationUuid) {
    id
    status
    fromUser {
      ...UserInfo
    }
    toUser {
      ...UserInfo
    }
  }
}
    ${UserInfoFragmentDoc}`;

/**
 * __useGetInvitationsFromFamilyCaregiversQuery__
 *
 * To run a query within a React component, call `useGetInvitationsFromFamilyCaregiversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsFromFamilyCaregiversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsFromFamilyCaregiversQuery({
 *   variables: {
 *      organisationUuid: // value for 'organisationUuid'
 *   },
 * });
 */
export function useGetInvitationsFromFamilyCaregiversQuery(baseOptions: Apollo.QueryHookOptions<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables> & ({ variables: GetInvitationsFromFamilyCaregiversQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>(GetInvitationsFromFamilyCaregiversDocument, options);
      }
export function useGetInvitationsFromFamilyCaregiversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>(GetInvitationsFromFamilyCaregiversDocument, options);
        }
// @ts-ignore
export function useGetInvitationsFromFamilyCaregiversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>;
export function useGetInvitationsFromFamilyCaregiversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvitationsFromFamilyCaregiversQuery | undefined, GetInvitationsFromFamilyCaregiversQueryVariables>;
export function useGetInvitationsFromFamilyCaregiversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>(GetInvitationsFromFamilyCaregiversDocument, options);
        }
export type GetInvitationsFromFamilyCaregiversQueryHookResult = ReturnType<typeof useGetInvitationsFromFamilyCaregiversQuery>;
export type GetInvitationsFromFamilyCaregiversLazyQueryHookResult = ReturnType<typeof useGetInvitationsFromFamilyCaregiversLazyQuery>;
export type GetInvitationsFromFamilyCaregiversSuspenseQueryHookResult = ReturnType<typeof useGetInvitationsFromFamilyCaregiversSuspenseQuery>;
export type GetInvitationsFromFamilyCaregiversQueryResult = Apollo.QueryResult<GetInvitationsFromFamilyCaregiversQuery, GetInvitationsFromFamilyCaregiversQueryVariables>;